import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useBreakpoint } from '../hooks/useBreakpoint';
import Logo from './AppLogo';

const C = {
  /* Dark band */
  dark:        "#0d2e1a",
  darkMid:     "#112819",
  darkCard:    "#163322",
  darkBorder:  "#1e4a2e",
  darkBorder2: "#244f32",
  /* Greens */
  green:       "#1e9254",
  greenLight:  "#2ab76b",
  greenTint:   "#eef8f3",
  greenBorder: "#a7d9bc",
  /* On-dark text */
  onDark:      "#FFFFFF",
  onDarkSub:   "rgba(255,255,255,0.55)",
  onDarkFaint: "rgba(255,255,255,0.28)",
  /* Utility */
  serif:  "'Instrument Serif', Georgia, serif",
  sans:   "'DM Sans', -apple-system, BlinkMacSystemFont, sans-serif",
  tx:     "all 0.2s cubic-bezier(.4,0,.2,1)",
};

const COLUMNS = [
  {
    heading: "Categories",
    links: [
      { label: "Cleaning & Laundry",      path: "/services/cleaning" },
      { label: "Jirani Chef",             path: "/services/chef" },
      { label: "Plumbing",                path: "/services/plumbing" },
      { label: "Electrical",              path: "/services/electrical" },
      { label: "TV & Electronics Repair", path: "/services/electronics-repair" },
      { label: "Hair & Beauty",           path: "/services/hair-beauty" },
      { label: "Home Tutoring",           path: "/services/home-tutoring" },
      { label: "Photography",             path: "/services/photography" },
      { label: "Gardening",               path: "/services/gardening" },
      { label: "Carpentry & Furniture",   path: "/services/carpentry-furniture" },
      { label: "Moving & Relocation",     path: "/services/moving" },
      { label: "Babysitting & Childcare", path: "/services/childcare" },
      { label: "Fitness & Training",      path: "/services/fitness" },
      { label: "Auto Repair",             path: "/services/auto-repair" },
      { label: "Errands & Delivery",      path: "/services/errands-delivery" },
    ],
  },
  {
    heading: "For Clients",
    links: [
      { label: "How JiraniApp Works", path: "/how-it-works" },
      { label: "Find a JiraniPro",    path: "/find-a-jiranipro" },
      { label: "Browse by Location",  path: "/browse-by-location" },
      { label: "Customer Reviews",    path: "/customer-reviews" },
      { label: "JiraniApp Guarantee", path: "/guarantee" },
      { label: "Help & Support",      path: "/help" },
    ],
  },
  {
    heading: "For Professionals",
    links: [
      { label: "Become a JiraniPro", path: "/pro-signup" },
      { label: "Community Hub",      path: "/community-hub" },
      { label: "Tips & Resources",   path: "/tips" },
      { label: "Events",             path: "/events" },
      { label: "Guides",             path: "/guides" },
    ],
  },
  {
    heading: "Business",
    links: [
      { label: "JiraniApp for Business", path: "/business" },
      { label: "Property Management",    path: "/property-management" },
      { label: "Corporate Services",     path: "/corporate" },
      { label: "Partner with Us",        path: "/partner" },
      { label: "Contact Sales",          path: "/contact-sales" },
    ],
  },
  {
    heading: "Company",
    links: [
      { label: "About JiraniApp",    path: "/about" },
      { label: "Careers",            path: "/careers" },
      { label: "Trust & Safety",     path: "/trust-and-safety" },
      { label: "Press & News",       path: "/news" },
      { label: "Terms of Service",   path: "/terms" },
      { label: "Privacy Policy",     path: "/privacy" },
      { label: "Cookie Policy",      path: "/cookies" },
      { label: "Partnerships",       path: "/partnerships" },
      { label: "Affiliates",         path: "/affiliates" },
      { label: "Investor Relations", path: "/investors" },
    ],
  },
];

const SOCIALS = [
  {
    name: "TikTok",
    url: "https://www.tiktok.com/@jiraniapp",
    d: "M9 3v10.55A4 4 0 1 0 13 17V7h4a4 4 0 0 1-4-4z",
  },
  {
    name: "Instagram",
    url: "https://www.instagram.com/jiraniapp",
    d: "M12 2.163c3.204 0 3.584.012 4.85.07 1.366.062 2.633.334 3.608 1.308.975.975 1.246 2.242 1.308 3.608.058 1.265.07 1.645.07 4.85s-.012 3.584-.07 4.85c-.062 1.366-.334 2.633-1.308 3.608-.975.975-2.242 1.246-3.608 1.308-1.265.058-1.645.07-4.85.07s-3.584-.012-4.85-.07c-1.366-.062-2.633-.334-3.608-1.308-.975-.975-1.246-2.242-1.308-3.608C2.175 15.584 2.163 15.204 2.163 12s.012-3.584.07-4.85c.062-1.366.334-2.633 1.308-3.608C4.516 2.497 5.783 2.225 7.15 2.233 8.415 2.175 8.795 2.163 12 2.163zm0-2.163C8.741 0 8.332.014 7.052.072 5.197.157 3.355.673 2.014 2.014.673 3.355.157 5.197.072 7.052.014 8.332 0 8.741 0 12c0 3.259.014 3.668.072 4.948.085 1.855.601 3.697 1.942 5.038 1.341 1.341 3.183 1.857 5.038 1.942C8.332 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 1.855-.085 3.697-.601 5.038-1.942 1.341-1.341 1.857-3.183 1.942-5.038.058-1.28.072-1.689.072-4.948 0-3.259-.014-3.668-.072-4.948-.085-1.855-.601-3.697-1.942-5.038C20.645.673 18.803.157 16.948.072 15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 1 0 0 12.324 6.162 6.162 0 0 0 0-12.324zM12 16a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm6.406-11.845a1.44 1.44 0 1 0 0 2.881 1.44 1.44 0 0 0 0-2.881z",
  },
  {
    name: "LinkedIn",
    url: "https://www.linkedin.com/company/jiraniapp",
    d: "M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 0 1-2.063-2.065 2.064 2.064 0 1 1 2.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z",
  },
  {
    name: "X",
    url: "https://twitter.com/jiraniapp",
    d: "M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.747l7.73-8.835L1.254 2.25H8.08l4.261 5.635 5.903-5.635zm-1.161 17.52h1.833L7.084 4.126H5.117z",
  },
  {
    name: "Facebook",
    url: "https://www.facebook.com/jiraniapp",
    d: "M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z",
  },
];

/* ── Footer link item — font size steps down on mobile so the fuller
   15-item category column fits an accordion row comfortably. ── */
function FooterLink({ label, path }) {
  const navigate = useNavigate();
  const { isMobile } = useBreakpoint();
  const [h, setH] = useState(false);
  return (
    <li style={{ marginBottom: isMobile ? 7 : 9 }}>
      <span
        onClick={() => navigate(path)}
        onMouseEnter={() => setH(true)}
        onMouseLeave={() => setH(false)}
        style={{
          fontSize: isMobile ? 12 : 13,
          color: h ? C.onDark : C.onDarkSub,
          cursor: "pointer",
          lineHeight: 1.4,
          fontFamily: C.sans,
          transition: C.tx,
          display: "inline-block",
        }}
      >
        {label}
      </span>
    </li>
  );
}

/* ── Mobile accordion section ── */
function MobileSection({ col, open, onToggle, navigate }) {
  return (
    <div style={{ borderBottom: `1px solid ${C.darkBorder}` }}>
      <button
        onClick={onToggle}
        style={{
          width: "100%", display: "flex", alignItems: "center",
          justifyContent: "space-between",
          padding: "14px 0",
          background: "none", border: "none", cursor: "pointer",
          fontFamily: C.sans,
        }}
      >
        <span style={{
          fontSize: 11.5, fontWeight: 700, color: C.onDark,
          letterSpacing: ".03em", textTransform: "uppercase",
        }}>
          {col.heading}
        </span>
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none"
          stroke={C.onDarkSub} strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"
          style={{ transform: open ? "rotate(180deg)" : "rotate(0deg)", transition: C.tx }}>
          <path d="M6 9l6 6 6-6"/>
        </svg>
      </button>

      <div style={{
        maxHeight: open ? 600 : 0,
        overflow: "hidden",
        transition: "max-height 0.28s cubic-bezier(.4,0,.2,1)",
      }}>
        <ul style={{
          listStyle: "none", margin: 0, padding: "0 0 14px",
          display: col.links.length > 8 ? "grid" : "block",
          gridTemplateColumns: col.links.length > 8 ? "1fr 1fr" : "none",
          columnGap: col.links.length > 8 ? 16 : 0,
        }}>
          {col.links.map((link, j) => (
            <FooterLink key={j} label={link.label} path={link.path} />
          ))}
        </ul>
      </div>
    </div>
  );
}

export default function Footer() {
  const navigate = useNavigate();
  const { isMobile, isTablet } = useBreakpoint();
  const [openSections, setOpenSections] = useState({});
  const [ctaHov, setCtaHov] = useState(false);

  const toggle = (i) => setOpenSections(prev => ({ ...prev, [i]: !prev[i] }));

  const padX = isMobile ? 20 : isTablet ? 32 : 48;

  return (
    <footer style={{
      background: C.dark,
      fontFamily: C.sans,
      position: "relative",
      overflow: "hidden",
    }}>
      {/* Ambient glows */}
      <div style={{
        position: "absolute", top: -100, left: -100,
        width: 400, height: 400, borderRadius: "50%",
        background: "radial-gradient(circle, rgba(30,146,84,.14) 0%, transparent 70%)",
        pointerEvents: "none",
      }}/>
      <div style={{
        position: "absolute", bottom: 0, right: -80,
        width: 320, height: 320, borderRadius: "50%",
        background: "radial-gradient(circle, rgba(30,146,84,.08) 0%, transparent 70%)",
        pointerEvents: "none",
      }}/>

      {/* ── CTA band ── */}
      <div style={{
        borderBottom: `1px solid ${C.darkBorder}`,
        padding: isMobile ? "48px 20px" : "64px 48px",
        position: "relative",
      }}>
        <div style={{
          maxWidth: 1200, margin: "0 auto",
          display: "flex",
          flexDirection: isMobile ? "column" : "row",
          alignItems: isMobile ? "flex-start" : "center",
          justifyContent: "space-between",
          gap: isMobile ? 28 : 40,
        }}>
          {/* Left: brand close */}
          <div style={{ maxWidth: 520 }}>
            <div style={{ marginBottom: 16 }}>
              <div onClick={() => navigate("/")} style={{ cursor: "pointer", display: "inline-block" }}>
                <Logo theme="onDark" />
              </div>
            </div>

            <h2 style={{
              fontFamily: C.serif,
              fontSize: isMobile ? 28 : 38,
              fontWeight: 400,
              color: C.onDark,
              lineHeight: 1.08,
              letterSpacing: "-0.03em",
              margin: "0 0 12px",
            }}>
              Kenya's most trusted<br/>
              <em style={{ color: C.greenLight, fontStyle: "italic" }}>home services platform</em>
            </h2>

            <p style={{
              fontSize: isMobile ? 13.5 : 14.5,
              color: C.onDarkSub,
              lineHeight: 1.65,
              margin: 0,
              maxWidth: 400,
            }}>
              Verified professionals, M-Pesa payments, and a money-back guarantee across Nairobi, Mombasa, Kisumu, and beyond.
            </p>
          </div>

          {/* Right: CTA card */}
          <div style={{
            background: C.darkCard,
            border: `1.5px solid ${C.darkBorder2}`,
            borderRadius: 20,
            padding: isMobile ? "24px 20px" : "28px 28px",
            flexShrink: 0,
            width: isMobile ? "100%" : 300,
          }}>
            <div style={{
              fontFamily: C.serif, fontSize: 18, fontStyle: "italic",
              color: C.onDark, marginBottom: 6, letterSpacing: "-0.01em",
            }}>
              Ready to get started?
            </div>
            <p style={{
              fontSize: 13, color: C.onDarkSub, lineHeight: 1.6,
              margin: "0 0 20px", fontFamily: C.sans,
            }}>
              Find a verified professional near you in under two minutes.
            </p>

            <button
              onClick={() => navigate("/search")}
              onMouseEnter={() => setCtaHov(true)}
              onMouseLeave={() => setCtaHov(false)}
              style={{
                width: "100%", height: 44, borderRadius: 999,
                background: ctaHov ? C.greenLight : C.green,
                border: "none", color: "#fff",
                fontFamily: C.sans, fontSize: 13.5, fontWeight: 600,
                cursor: "pointer", transition: C.tx,
                display: "flex", alignItems: "center", justifyContent: "center", gap: 7,
                boxShadow: ctaHov ? "0 6px 20px rgba(42,183,107,.3)" : "none",
                marginBottom: 12,
              }}
            >
              Find a JiraniPro
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M5 12h14M12 5l7 7-7 7"/>
              </svg>
            </button>

            <button
              onClick={() => navigate("/pro-signup")}
              style={{
                width: "100%", height: 40, borderRadius: 999,
                background: "transparent",
                border: `1.5px solid ${C.darkBorder2}`,
                color: C.onDarkSub,
                fontFamily: C.sans, fontSize: 13, fontWeight: 500,
                cursor: "pointer", transition: C.tx,
              }}
              onMouseEnter={e => { e.currentTarget.style.borderColor = "rgba(42,183,107,.4)"; e.currentTarget.style.color = C.onDark; }}
              onMouseLeave={e => { e.currentTarget.style.borderColor = C.darkBorder2; e.currentTarget.style.color = C.onDarkSub; }}
            >
              Become a JiraniPro
            </button>
          </div>
        </div>
      </div>

      {/* ── Link columns ── */}
      <div style={{
        maxWidth: 1200, margin: "0 auto",
        padding: isMobile ? `32px ${padX}px 24px` : `52px ${padX}px 44px`,
      }}>
        {isMobile ? (
          <div>
            {COLUMNS.map((col, i) => (
              <MobileSection
                key={i}
                col={col}
                open={!!openSections[i]}
                onToggle={() => toggle(i)}
                navigate={navigate}
              />
            ))}
          </div>
        ) : (
          <div style={{
            display: "grid",
            gridTemplateColumns: isTablet
              ? "repeat(3, 1fr)"
              : "1.6fr 1fr 1fr 1fr 1.1fr",
            gap: isTablet ? "28px 24px" : "0 32px",
          }}>
            {COLUMNS.map((col, i) => (
              <div key={i}>
                <p style={{
                  fontSize: 10.5, fontWeight: 700, color: C.onDarkFaint,
                  textTransform: "uppercase", letterSpacing: ".1em",
                  margin: "0 0 16px", fontFamily: C.sans,
                }}>
                  {col.heading}
                </p>
                <ul style={{ listStyle: "none", margin: 0, padding: 0 }}>
                  {col.links.map((link, j) => (
                    <FooterLink key={j} label={link.label} path={link.path} />
                  ))}
                </ul>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* ── Bottom bar ── */}
      <div style={{
        borderTop: `1px solid ${C.darkBorder}`,
        padding: isMobile ? "18px 20px 26px" : "18px 48px",
      }}>
        {isMobile ? (
          /* ── MOBILE bottom bar: logo+slogan left, copyright+address right, socials centered below ── */
          <div style={{
            maxWidth: 1200, margin: "0 auto",
            display: "flex",
            flexDirection: "column",
            gap: 16,
          }}>
            <div style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "flex-start",
              justifyContent: "space-between",
              gap: 12,
            }}>
              {/* Left: logo + slogan — sized to match the homepage nav-bar's
                  small logo rather than scaling down the larger desktop mark. */}
              <div style={{
                display: "flex", flexDirection: "column", gap: 4,
              }}>
                <div onClick={() => navigate("/")} style={{ cursor: "pointer", lineHeight: 0 }}>
                  <Logo theme="onDark" />
                </div>
                <span style={{ fontSize: 10, color: C.onDarkFaint, fontFamily: C.sans, fontStyle: "italic" }}>
                  Right next door
                </span>
              </div>

              {/* Right: copyright + address */}
              <div style={{
                display: "flex", flexDirection: "column", alignItems: "flex-end",
                textAlign: "right", gap: 3,
              }}>
                <span style={{ fontSize: 10.5, color: C.onDarkFaint, fontFamily: C.sans, whiteSpace: "nowrap" }}>
                  © JiraniApp Ltd. 2025
                </span>
                <span style={{ fontSize: 9.5, color: C.onDarkFaint, fontFamily: C.sans, opacity: 0.75 }}>
                  Delta Corner, Chiromo Road, Westlands, Nairobi
                </span>
              </div>
            </div>

            <div style={{
              display: "flex", alignItems: "center", justifyContent: "center", gap: 15,
            }}>
              {SOCIALS.map((s, i) => (
                <a
                  key={i}
                  href={s.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  title={s.name}
                  style={{
                    color: C.onDarkFaint,
                    display: "inline-flex", alignItems: "center",
                    transition: C.tx,
                  }}
                  onMouseEnter={e => e.currentTarget.style.color = C.greenLight}
                  onMouseLeave={e => e.currentTarget.style.color = C.onDarkFaint}
                >
                  <svg viewBox="0 0 24 24" width="13" height="13" fill="currentColor">
                    <path d={s.d}/>
                  </svg>
                </a>
              ))}
            </div>
          </div>
        ) : (
          /* ── DESKTOP bottom bar: unchanged ── */
          <div style={{
            maxWidth: 1200, margin: "0 auto",
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between",
          }}>

            <div style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              gap: 12,
              flexWrap: "wrap",
            }}>
              <div style={{ display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap" }}>
                <div onClick={() => navigate("/")} style={{ cursor: "pointer", lineHeight: 0 }}>
                  <Logo theme="onDark" />
                </div>
                <span style={{ fontSize: 12, color: C.onDarkFaint, fontFamily: C.sans }}>
                  © JiraniApp Ltd. 2025 · Nairobi, Kenya
                </span>
              </div>
              <span style={{
                fontSize: 11, color: C.onDarkFaint, fontFamily: C.sans,
                borderLeft: `1px solid ${C.darkBorder}`,
                paddingLeft: 12,
                display: "inline",
              }}>
                Lipa Na M-Pesa · Verified Pros · Backed Guarantee
              </span>
            </div>

            <div style={{
              display: "flex", alignItems: "center", gap: 18,
            }}>
              {SOCIALS.map((s, i) => (
                <a
                  key={i}
                  href={s.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  title={s.name}
                  style={{
                    color: C.onDarkFaint,
                    display: "inline-flex", alignItems: "center",
                    transition: C.tx,
                  }}
                  onMouseEnter={e => e.currentTarget.style.color = C.greenLight}
                  onMouseLeave={e => e.currentTarget.style.color = C.onDarkFaint}
                >
                  <svg viewBox="0 0 24 24" width="17" height="17" fill="currentColor">
                    <path d={s.d}/>
                  </svg>
                </a>
              ))}
            </div>

          </div>
        )}
      </div>
    </footer>
  );
}